/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ a: NonNullable<unknown>, b: NonNullable<unknown> }} Rounds_Seating_SwappedInputs */



/**
* | output |
* | --- |
* | "Swapped {a} with {b}" |
*
* @param {Rounds_Seating_SwappedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_swapped = /** @type {((inputs: Rounds_Seating_SwappedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_SwappedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échange de ${i?.a} et ${i?.b} effectué`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Intercambiados ${i?.a} y ${i?.b}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Troca entre ${i?.a} e ${i?.b} realizada`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Scambiati ${i?.a} e ${i?.b}`)
	return /** @type {LocalizedString} */ (`Swapped ${i?.a} with ${i?.b}`)
});